// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"MenuButton_menuButton__21vyA","labelCopy":"MenuButton_labelCopy__3wkac","up":"MenuButton_up__3TaCa","right":"MenuButton_right__1BFI2","down":"MenuButton_down__3br0q"};